import { render, staticRenderFns } from "./AddPodcastModal.vue?vue&type=template&id=55435415"
import script from "./AddPodcastModal.vue?vue&type=script&lang=ts"
export * from "./AddPodcastModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports